import React, { useEffect, useState } from "react";
import { FullWidthLoader } from "../../../components/full-width-loader";
import { useLoyaltyAllBrand } from "../../../components/loyalty-all-brand-provider";

export default function ContainerCM({ Component, configFields }: any) {
  const [loading, setLoading] = useState(false);
  const [fieldsConfig] = useState(configFields);
  const loyaltyAllBrand = useLoyaltyAllBrand();

  useEffect(() => {
    if (loyaltyAllBrand?.length) {
      setLoading(false);
    }
  }, [loyaltyAllBrand]);

  useEffect(() => {
    setLoading(true);
    
    let newOptions: any = [];

    if (loyaltyAllBrand) {
      newOptions = loyaltyAllBrand.reduce(
        (listBrands: any, currentBrand: any) => ({
          ...listBrands,
          [currentBrand.ticker]: {
            label: currentBrand.ticker,
          },
        }),
        { "": "" }
      );
    }

    fieldsConfig.form.find(
      (fieldForm: any) =>
        fieldForm.fieldName === "defaultBrand" && (fieldForm.optionDisplay = newOptions)
    );
    setLoading(false);
  }, [configFields, fieldsConfig.form, loyaltyAllBrand]);

  return <div>{loading ? <FullWidthLoader /> : <Component fieldsConfig={fieldsConfig} />}</div>;
}
